
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/6-best-halloween-events-in-the-uk",
      function () {
        return require("private-next-pages/blog/6-best-halloween-events-in-the-uk.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/6-best-halloween-events-in-the-uk"])
      });
    }
  